import { NfColumnTypes } from '@northfork/ag-grid'
import { InlineEditDataType } from '@northfork/ag-grid-angular'
import { FilterType, FilterValueInputType } from '../models/filter.model'

/**
 * Get the data type for the filter api. When passed to the server, this needs to be translated
 */
export function getDataType(type: string): InlineEditDataType {
  switch (type) {
    case 'agSetColumnFilter':
      return InlineEditDataType.Select
    case 'text':
    case 'textFilter':
      return InlineEditDataType.String
    case 'Identifier':
    case 'numberFilter':
      return InlineEditDataType.Number
    case 'dateFilter':
      return InlineEditDataType.Date
    case 'dateTimeFilter':
      return InlineEditDataType.DateTime
    case 'timeFilter':
      return InlineEditDataType.Time
    default:
      return InlineEditDataType.String
  }
}

/**
 * Get the specific column type for editing
 */
export function getColumnType(type: string): string {
  switch (type) {
    case NfColumnTypes.Number:
    case NfColumnTypes.Integer:
    case NfColumnTypes.Identifier:
      return 'number'
    case NfColumnTypes.Date:
      return 'date'
    case NfColumnTypes.DateTime:
      return 'dateTime'
    case 'Boolean':
      return 'set'
    default:
      return 'text'
  }
}

/**
 * Get Input type for a filter value based on filter type and operator.
 */
export function getFilterValueInputType(
  filterType: FilterType | null,
  operatorType: string | null,
): FilterValueInputType | null {
  switch (filterType?.type) {
    case 'text':
      switch (operatorType) {
        case 'blank':
        case 'notBlank':
          return 'none'
        default:
          return 'textInput'
      }
    case 'number':
      switch (operatorType) {
        case 'inRange':
          return 'numberRangeInput'
        case 'in':
          return 'numberInInput'
        default:
          return 'numberInput'
      }
    case 'identifier':
      switch (operatorType) {
        case 'inRange':
          return 'identifierRangeInput'
        case 'in':
        case 'notIn':
          return 'identifierInInput'
        default:
          return 'identifierInput'
      }
    case 'date':
      switch (operatorType) {
        case 'inRange':
          return 'dateRange'
        case 'blank':
        case 'notBlank':
          return 'none'
        default:
          return 'datePicker'
      }
    case 'time':
      switch (operatorType) {
        case 'inRange':
          return 'timeRange'
        case 'blank':
        case 'notBlank':
          return 'none'
        default:
          return 'timePicker'
      }
    case 'datetime':
      switch (operatorType) {
        case 'inRange':
          return 'dateTimeRange'
        case 'blank':
        case 'notBlank':
          return 'none'
        default:
          return 'dateTimePicker'
      }
    case 'set':
      switch (operatorType) {
        default:
          return 'multiSelector'
      }
    default:
      return null
  }
}
